export default __webpack_public_path__ + "22683d3e751bb45c654bb11e02f17dbb.jpg";